import { LayoutHOC } from "base/ui/layout/layout";
import { wasteHandoverRegistrationPrintRoutes } from "./routes";
import { createPrintPDF } from "./printPDF";

export const createWasteHandoverRegistrationPrintPDFPage = (layoutHOC: LayoutHOC) => {
    const PrintPDF = createPrintPDF()

    const WasteHandoverRegistrationPrintPage = layoutHOC(wasteHandoverRegistrationPrintRoutes);

    return () => (
        <WasteHandoverRegistrationPrintPage
            PrintPDF={PrintPDF}
        />
    );
};

